@if (editable) {
  <div class="w-100 mt-0 mb-2">
    <div class="section-header mt-0 mb-3">
      <mat-icon>format_list_bulleted</mat-icon>
      <span>{{ "generic.options" | translate }}</span>
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="drag-list px-0 bg-transparent border-0 my-3">
      @for (choice of question.choices; track choice; let optionIndex = $index) {
        <div class="option-row shadow-sm mb-3 rounded bg-white d-flex align-items-center"
          cdkDrag>
          <!-- Drag Handle -->
          <div class="drag-handle-grid mr-3" cdkDragHandle style="cursor: grab; color: #ccc;">
            <mat-icon>grid_view</mat-icon>
          </div>
          <!-- Content -->
          <div class="flex-grow-1 d-flex align-items-center">
            <!-- Checkbox/Radio Indicator (Visual only) -->
            @if (isMultipleChoiceQuestion) {
              <div class="mr-3">
                <div class="option-type-indicator radio"></div>
              </div>
            }
            @if (isCheckboxQuestion) {
              <div class="mr-3">
                <div class="option-type-indicator checkbox"></div>
              </div>
            }
            <!-- Input -->
            <div class="option-input-wrapper w-100 d-flex align-items-center">
              <input type="text" [disabled]="!editable" [required]="true" class="option-text-input flex-grow-1 mr-3"
                name="question_{{ question.id }}__{{choice.id}}" [(ngModel)]="choice.title" placeholder="Option">
              <div class="d-flex flex-column ml-3">
                <mat-slide-toggle color="primary" [(ngModel)]="choice.customs.has_open_response" [disabled]="!editable">
                  {{ 'modals.modal-survey-details.allow-open-answer' | translate }}
                </mat-slide-toggle>
                @if (choice.customs.has_open_response) {
                  <mat-slide-toggle color="primary"
                    [(ngModel)]="choice.customs.open_answer_is_mandatory" [disabled]="!editable" class="mt-2">
                    {{ 'generic.required' | translate }}
                  </mat-slide-toggle>
                }
              </div>
            </div>
          </div>
          <!-- Delete Action -->
          @if (editable && question.choices.length > 2) {
            <button mat-icon-button class="delete-option-btn ml-2"
              (click)="removeChoice(choice.id)">
              <mat-icon>close</mat-icon>
            </button>
          }
          <!-- Preview HELPER for Drag -->
          <div *cdkDragPreview class="cdk-drag-preview p-3 border rounded shadow bg-white d-flex align-items-center">
            <mat-icon class="mr-3 text-muted">grid_view</mat-icon>
            <span>{{ choice.title }}</span>
          </div>
          <div *cdkDragPlaceholder class="cdk-drag-placeholder"></div>
        </div>
      }
    </div>
    <!-- Add Option Button -->
    @if (editable) {
      <div class="mt-2">
        <button mat-button class="add-option-btn" (click)="addChoice()">
          <mat-icon>add</mat-icon> {{ "pages.frameworks.component.buttons.add-criteria-option" | translate }}
        </button>
      </div>
    }
  </div>
}

<!-- Read-only view for non-editable state (Response mode) -->
@if (!editable) {
  <div class="mt-0 mb-3 row">
    <div class="col-12 row">
      <div class="section-header col-12 mb-2">
        <mat-icon>format_list_bulleted</mat-icon>
        <span>{{ "generic.options" | translate }}</span>
      </div>
      @if (isMultipleChoiceQuestion) {
        <mat-radio-group class="col-12" disabled>
          @for (choice of question.choices; track choice) {
            <div class="row">
              <div class="col-12 mb-2">
                <mat-radio-button [value]="choice.id" [disabled]="true">{{ choice.title }}</mat-radio-button>
              </div>
            </div>
          }
        </mat-radio-group>
      }
      @if (isCheckboxQuestion) {
        <div class="col-12">
          @for (choice of question.choices; track choice) {
            <div class="row">
              <div class="col-12 mb-2">
                <mat-checkbox disabled>{{ choice.title }}</mat-checkbox>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
